import { FunctionComponent, ReactNode } from 'react';
import Style from "./PublicApp.style";
import { Footer } from "View/Application/Footer/Footer";
import { Content } from "View/Application/Content/Content";


type TProps = {
  children?: ReactNode;
};

export const PublicApp: FunctionComponent<TProps> = ({ children, ...props }) => {
  return (
    <Style { ...props }>
      <Content>
        { children }
      </Content>
      <Footer  />
    </Style>
  );
}
